<template>
  <section class="pagination-area ptb-80 pt-0">
    <div class="pagination">
      <span class="ico back__ico" @click="prevPage">
        <svg
          width="8"
          height="14"
          viewBox="0 0 8 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.70711 0.292893C8.09763 0.683417 8.09763 1.31658 7.70711 1.70711L2.41421 7L7.70711 12.2929C8.09763 12.6834 8.09763 13.3166 7.70711 13.7071C7.31658 14.0976 6.68342 14.0976 6.29289 13.7071L0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893Z"
            fill="#557EFB"
          />
        </svg>
      </span>
      <div v-for="n in length" :key="n">
        <span
          class="page "
          @click="changePage(n)"
          :class="{ active: active == n }"
        >
          {{ n }}
        </span>
      </div>
      <!-- <span
        class="page "
        @click="changePage(1)"
        :class="{ active: active == 1 }"
      >
        1
      </span>
      <span
        class="page"
        @click="changePage(2)"
        :class="{ active: active == 2 }"
      >
        2
      </span>
      <span
        class="page"
        @click="changePage(3)"
        :class="{ active: active == 3 }"
      >
        3
      </span>
      <span
        class="page"
        @click="changePage(4)"
        :class="{ active: active == 4 }"
      >
        4
      </span>

      <span class="page">
        ....
      </span>
      <span
        class="page"
        @click="changePage(20)"
        :class="{ active: active == 20 }"
      >
        20
      </span> -->
      <span class="ico next__ico" @click="nextPage">
        <svg
          width="8"
          height="14"
          viewBox="0 0 8 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7.70711 6.29289C8.09763 6.68342 8.09763 7.31658 7.70711 7.70711L1.70711 13.7071C1.31658 14.0976 0.683417 14.0976 0.292893 13.7071C-0.0976311 13.3166 -0.0976311 12.6834 0.292893 12.2929L5.58579 7L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
            fill="#557EFB"
          />
        </svg>
      </span>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      active: 1
    };
  },
  props: {
    length: {
      type: Number
    }
  },
  methods: {
    changePage(page) {
      this.active = page;
      this.emit();
    },
    nextPage() {
      if (this.active < this.length) {
        this.active += 1;
        this.emit();
      }
    },
    prevPage() {
      if (this.active > 1) {
        this.active -= 1;
        this.emit();
      }
    },
    emit() {
      this.$emit("page-changed", this.active);
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination-area {
  margin: 0 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  .pagination {
    max-width: 410px;
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .page {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: 0.05em;
      color: #8d99a0;
      &.active {
        background: #557ffb1f;
      }
    }
    .next__ico,
    .back__ico {
      // margin-right: 45px;
      cursor: pointer;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        background: #557ffb1f;
      }
    }
  }
}
</style>
